import type { RefCallbackWithCleanup, RefObject } from 'react';

/**
 * A factory function which creates a ref callback that assigns the node to the provided
 * ref object. The cleanup function sets the ref to `null`.
 *
 * This should only be used in conjunction with `refMerge`. Otherwise, pass the
 * ref object directly to the `ref` prop.
 *
 * @param ref - The ref object to assign the node to.
 * @returns A ref callback that can be attached to a React element.
 */
export function refAssign<T extends Node>(
  ref: RefObject<T | null>
): RefCallbackWithCleanup<T> {
  return (node: T) => {
    ref.current = node;
    return () => {
      ref.current = null;
    };
  };
}
